
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-blog-post-hero{
  position:relative;
  display:flex;
  font-family:var(--ff-dmsans);
  flex-direction:column;
  align-items:center;
  justify-content:center;
}

  .se-blog-post-hero .background-dimensions{
    width:100vw;
    height:20vh;
  }

  @media (min-width: 768px){

  .se-blog-post-hero .background-dimensions{
      height:min(48vh, 400px)
  }
    }

  .se-blog-post-hero .background-container{
    top:0;
    background:var(--brand-primary-1);
    display:flex;
    justify-content:flex-end;
    width:100%;
    height:90%;
    max-height:400px;
    overflow:hidden;
    position:absolute;
    z-index:-1;
  }

  .se-blog-post-hero [cloned-slot-name='hero-image']{
    width:100%;
  }

  .se-blog-post-hero [cloned-slot-name='hero-image'] picture > img{
      width:100%;
      height:100%;
      aspect-ratio:16/9;
      object-fit:cover;
      display:flex;
    }

  .se-blog-post-hero .image-caption{
    padding:1.25rem 0 1.4rem;
    font-size:var(--fs-sm);
  }

  @media (min-width: 768px){

  .se-blog-post-hero .image-caption{
      padding:1.25rem 0 2.6rem
  }
    }

  .se-blog-post-hero .content{
    margin:0px -3rem;
    padding:0px 3rem;
    background:var(--brand-neutral-white);
  }

  .se-blog-post-hero .hero-eyebrow{
    display:flex;
    align-items:center;
    gap:var(--spacing-3);
    padding-bottom:var(--spacing-6);
  }

  @media (min-width: 768px){

  .se-blog-post-hero .hero-eyebrow{
      gap:var(--spacing-4)
  }
    }

  .se-blog-post-hero .series,
  .se-blog-post-hero .separator{
    display:flex;
    align-items:center;
    text-transform:uppercase;
    gap:var(--spacing-3);
    font-size:var(--fs-sm);
    font-weight:(--fw-medium);
    letter-spacing:1px;
    margin:0;
  }

  .se-blog-post-hero .title{
    padding-bottom:var(--spacing-4);
    font-weight:var(--fw-medium);
  }

  .se-blog-post-hero .social > div{
    display:flex;
    gap:var(--spacing-7);
    padding-bottom:var(--spacing-12);
  }

  .se-blog-post-hero .flex-horizontal{
    display:inline-flex;
    padding-bottom:var(--spacing-4);
    gap:var(--spacing-4);
  }

  .se-blog-post-hero .flex-horizontal > div{
    display:flex;
  }

  .se-blog-post-hero se-container{
    margin-top:6.25rem;
  }

  .se-blog-post-hero--with-image .background-container{
      height:12%;
    }

  @media (min-width: 768px){

  .se-blog-post-hero--with-image .background-container{
        height:90%
    }
      }

  .se-blog-post-hero--with-image se-container{
      margin-top:var(--spacing-8);
    }

  @media (min-width: 768px){

  .se-blog-post-hero--with-image se-container{
        margin-top:6.25rem
    }
      }

  .se-blog-post-hero--with-image .content{
      padding-top:0;
    }

  .se-blog-post-hero--no-image .content{
      padding-top:var(--spacing-4);
    }

  @media (min-width: 768px){

  .se-blog-post-hero--no-image .content{
        padding-top:var(--spacing-8)
    }
      }
`;